import { Component } from '@angular/core';

@Component({
  selector: 'i-star',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 76 74" fill="none">
      <path
        fill="currentColor"
        d="M27.8738 0C25.7653 0 23.7039 1.07309 22.5931 3.02159C21.3224 5.24307 19.1479 9.37541 17.4065 14.4208C17.3877 14.4867 17.3218 14.5338 17.2465 14.5338C11.9093 14.6373 7.30631 15.428 4.80244 15.9457C2.6092 16.407 0.952497 18.026 0.302996 20.031C-0.346505 22.036 0.0394305 24.3233 1.54552 25.9895C3.26811 27.8815 6.52503 31.2325 10.7797 34.4518C10.8362 34.4895 10.855 34.5742 10.8362 34.6401C9.28306 39.7419 8.61473 44.3638 8.33234 46.9147C8.0876 49.1456 9.12303 51.2165 10.8268 52.459C12.5306 53.7015 14.8273 54.0404 16.87 53.1179C19.2044 52.0636 23.3932 50.0022 27.7703 46.9429C27.8268 46.9053 27.9115 46.9053 27.968 46.9429C32.3451 49.9928 36.5339 52.0636 38.8683 53.1179C40.9109 54.0404 43.2077 53.7015 44.9115 52.459C46.6152 51.2165 47.6507 49.1456 47.4059 46.9147C47.1236 44.3732 46.4552 39.7419 44.9021 34.6401C44.8832 34.5742 44.9115 34.4989 44.9586 34.4518C49.2133 31.2325 52.4796 27.8909 54.1928 25.9895C55.6989 24.3328 56.0848 22.0454 55.4353 20.031C54.7858 18.0166 53.1291 16.3975 50.9358 15.9457C48.432 15.428 43.829 14.6373 38.4918 14.5338C38.4259 14.5338 38.36 14.4867 38.3318 14.4208C36.5903 9.38482 34.4159 5.24307 33.1452 3.02159C32.0344 1.07309 29.9824 0 27.8644 0L27.8738 0Z"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconStar {}
